/** Copy of the spPayments page (Operations), ported from VentaHub. */
export const spPayments = {
  words: {
    noun: 'payment',
    record: 'Record a payment',
    document: 'service provider invoice',
    settled: 'paid',
  },
  title: 'SP payments',
  description: 'Payments made to service providers against their invoices.',
  empty: 'No sp payments to show',
  emptyHint: 'Nothing matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    party: 'Service provider',
    invoice: 'SP invoice',
    dates: 'Paid on',
    void: 'Include voided',
  },
  columns: {
    date: 'Paid on',
    invoice: 'SP invoice',
    amount: 'Amount',
    comment: 'Comment',
    valid: 'Status',
  },
} as const
